export const windowModeEnum = {
  left: 0,
  right: 1,
  top: 2,
  bottom: 3,
  spanning: 5
}